export const programAndPricingPendingChangesFields = [
  'rateSheetId',
  'finalBuyPrice',
  'programId',
  'productId',
  'principalAndInterest',
  'lockTerm',
  'rate',
];
